var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { display: "inline" } }, [
    _vm.history.length > 0
      ? _c(
          "div",
          [
            _c("h3", [_vm._v("Historia ofert:")]),
            _vm._l(_vm.history, function(historyItem, index) {
              return _c("div", { key: historyItem.id }, [
                _c("b", [_vm._v("Oferta " + _vm._s(index + 1))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" Utworzył: "),
                _c("b", [_vm._v(_vm._s(historyItem.created_by_name))]),
                _vm._v(" dnia "),
                _c("b", [_vm._v(_vm._s(historyItem.created_at))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" Ostatnia edycja: "),
                _c("b", [_vm._v(_vm._s(historyItem.last_edit_by_name))]),
                _vm._v(" dnia "),
                _c("b", [_vm._v(_vm._s(historyItem.last_edit_at))])
              ])
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }